import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "@/lib/firebase";
import { adminService } from "@/services/firebase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Wrench, AlertCircle } from "lucide-react";
import toast from "react-hot-toast";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const admin = await adminService.getByUid(userCredential.user.uid);
      
      if (!admin) {
        await auth.signOut();
        setError("Vous n'avez pas les droits d'acc�s administrateur.");
        toast.error("Acc�s refus�");
        return;
      }

      toast.success(`Bienvenue, ${admin.displayName || admin.email}!`);
      navigate("/admin");
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : "Erreur de connexion";
      setError("Email ou mot de passe incorrect.");
      console.error("Login error:", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark via-dark-light to-dark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Wrench className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-dark">Allo Artisan</h1>
            <p className="text-gray-500 text-sm mt-1">Dashboard Administrateur</p>
          </div>

          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3 text-red-600 text-sm">
              <AlertCircle className="w-5 h-5 flex-shrink-0" />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              label="Email"
              type="email"
              placeholder="admin@alloartisan.ci"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Input
              label="Mot de passe"
              type="password"
              placeholder="@ad22..!"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button
              type="submit"
              size="lg"
              rounded="xl"
              isLoading={loading}
              className="w-full"
            >
              Se connecter
            </Button>
          </form>

          <p className="text-center text-xs text-gray-400 mt-6">
            Accés réservé aux administrateurs autorisés.
          </p>
        </div>
      </div>
    </div>
  );
}
